import { render, staticRenderFns } from "./EditCoaSubType.vue?vue&type=template&id=575f85b8"
import script from "./EditCoaSubType.vue?vue&type=script&lang=js"
export * from "./EditCoaSubType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports